export function removeAllQueryParams() {
	const url = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
	window.history.pushState({}, "", url);
}
